import React from 'react'
import { Spinner } from '@instructure/ui-spinner'

const Loading = () => <Spinner size="large" margin="large" renderTitle="Loading data..." />

export { Loading }